import React from 'react';
import BaseFightCard from './BaseFightCard';
import '../../styles/fightCardV2.1.0/MatchmakingFightCard.scss';

const MatchmakingFightCard = ({ fight, selectedTeam, onClickCard }) => {
  return (
    <BaseFightCard
      fight={fight}
      selectedTeam={selectedTeam}
      tabComponent={<p className='matchmaking-fight-card-league-acronym'>{fight.sportLeague}</p>}
      onClickCard={onClickCard}
    />
  );
};

export default MatchmakingFightCard;
